import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=c1d75734&scoped=true&"
import script from "./ServicesView.vue?vue&type=script&lang=js&"
export * from "./ServicesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d75734",
  null
  
)

export default component.exports